import styled from 'styled-components';
import { Typ20 } from 'dc/Typ';
import Btn30 from 'dc/Btn30';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
`;

export const Text = styled(Typ20)`
  padding-right: 8px;
  color: ${props => (props.disabled ? '#cfd8dc' : '#607d8b')};

  &:hover {
    color: ${props => {
      if (props.disabled) {
        return '#cfd8dc';
      }
      if (props.checked || props.partiallyChecked) {
        return '#009483';
      }

      return '#00ab97';
    }};
  }
`;

export const Button = styled(Btn30)`
  ${props => (props.partiallyChecked ? 'background-color: #cfd8dc;' : null)}

  > i {
    ${props => (props.partiallyChecked ? 'color: #607d8b;' : null)}
  }

  &:disabled {
    ${props => (props.partiallyChecked ? 'background-color: #eceff1;' : null)}
  }

  &:disabled i {
    ${props => (props.partiallyChecked ? 'color: #cfd8dc;' : null)}
  }
`;
